import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { scrollToId } from "@/lib/site";

export function FinalCTA() {
  return (
    <section className="px-4 sm:px-10 py-16 sm:py-24" data-testid="final-cta-section">
      <Reveal>
        <div className="relative max-w-6xl mx-auto rounded-[36px] bg-[#0B1F3A] text-white overflow-hidden px-8 sm:px-16 py-20 sm:py-28 grain">
          <div className="pointer-events-none absolute -right-24 -bottom-24 h-[380px] w-[380px] rounded-full bg-[#C7A76C]/20 blur-3xl" />
          <div className="relative max-w-2xl">
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight">
              Your property journey starts with understanding.
            </h2>
            <p className="mt-6 text-white/70 text-base sm:text-lg leading-relaxed">
              Start with a conversation, get your questions answered, and explore your options with greater clarity.
            </p>
            <button onClick={() => scrollToId("booking")} className="btn-light mt-10" data-testid="final-cta-button">
              Choose Your Briefing Time <ArrowRight size={16} />
            </button>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
